import config from '../config'

const EVENTS      = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click']
const INACTIVE_MS = 30 * 60 * 1000   // 30 minutes
const THROTTLE_MS =  5 * 1000        // ignore rapid events within 5 s
const LS_KEY      = 'bahok_last_activity'

export default {
  data () {
    return {
      _logoutTimer:  null,
      _lastActivity: 0,
    }
  },

  methods: {
    _resetInactivityTimer () {
      const now = Date.now()
      if (now - this._lastActivity < THROTTLE_MS) return
      this._lastActivity = now

      // Write to localStorage so all other tabs know this tab is active
      localStorage.setItem(LS_KEY, now.toString())

      clearTimeout(this._logoutTimer)
      this._logoutTimer = setTimeout(() => this._checkAndLogout(), INACTIVE_MS)
    },

    _checkAndLogout () {
      // Before logging out, check if ANY tab was recently active
      const lastActivity = parseInt(localStorage.getItem(LS_KEY) || '0')
      const idleSince    = Date.now() - lastActivity

      if (idleSince < INACTIVE_MS) {
        // Another tab was active — reschedule for the remaining time
        clearTimeout(this._logoutTimer)
        this._logoutTimer = setTimeout(() => this._checkAndLogout(), INACTIVE_MS - idleSince)
        return
      }

      this._doLogout()
    },

    _onStorageChange (e) {
      if (e.key !== LS_KEY) return
      // Another tab just had activity — reset this tab's logout timer
      clearTimeout(this._logoutTimer)
      this._logoutTimer = setTimeout(() => this._checkAndLogout(), INACTIVE_MS)
    },

    _doLogout () {
      clearTimeout(this._logoutTimer)
      localStorage.removeItem(LS_KEY)
      config.postData('/admin/logout')
        .finally(() => {
          localStorage.removeItem('accessToken')
          this.$router.push('/auth/login')
        })
    },
  },

  mounted () {
    this._lastActivity = Date.now()
    localStorage.setItem(LS_KEY, this._lastActivity.toString())

    EVENTS.forEach(e => document.addEventListener(e, this._resetInactivityTimer, { passive: true }))
    window.addEventListener('storage', this._onStorageChange)

    this._resetInactivityTimer()
  },

  beforeDestroy () {
    clearTimeout(this._logoutTimer)
    EVENTS.forEach(e => document.removeEventListener(e, this._resetInactivityTimer))
    window.removeEventListener('storage', this._onStorageChange)
  },
}
